import { NAME as APP_NAME } from 'constants';
import * as I18n from 'circe/I18n';
import { getOptions } from 'domain/fuse/models/model';
import { getCouriers } from 'domain/tap/apis';
import { filterVehicleTypes } from 'domain/vehicle/utils';
import { getFleetByName } from 'domain/fleets/apis';
import { TEMP_CLASSIFICATIONS } from 'domain/operations/drivers/constants';
import { STRATEGY_TYPES } from 'domain/tap/constants';

export const NAME = `${APP_NAME}/VEHCILES`;

export const OWNERSHIP_TYPES = [
  { value: 'OWNER', label: I18n.str('owner', 'Owner') },
  { value: 'LEASER', label: I18n.str('leaser', 'Leaser') },
];
export const REDUCER_NAME = 'vehicles';

export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/vehicles/query`;

export const ROUTES = {
  ROOT: '/vehicles',
};

export const PAGE_NAME = 'vehicle';

export const SHOWN_FILTERS = () => [
  {
    name: I18n.str('equipmentId', 'Equipment Id ( name )'),
    type: 'Textfield',
    accessor: 'name',
    placeholder: I18n.str('enterEquipmentId', 'Type Equipment Id ( name )'),
  },
  {
    name: I18n.str('licensePlate', 'License Plate'),
    type: 'Textfield',
    accessor: 'licensePlate',
    placeholder: I18n.str('licensePlatePlaceHolder', 'e.g. 1234 A B C'),
    masked: true,
  },
];

export const HIDDEN_FILTERS = (vehicleTypes, baseCities) => [
  {
    name: I18n.str('baseCity', 'Base City'),
    type: 'Autocomplete',
    accessor: 'baseCity',
    optionName: 'base',
    api: false,
    options: getOptions(baseCities),
  },
  {
    name: I18n.str('transporter', 'Transporter'),
    type: 'Autocomplete',
    accessor: 'accountId',
    optionName: 'transporter',
    api: true,
    getOptions: getCouriers,
  },
  {
    name: I18n.str('vehicleType', 'Vehicle Type'),
    type: 'Autocomplete',
    accessor: 'vehicleType',
    optionName: 'vehicle',

    api: false,
    options: filterVehicleTypes(vehicleTypes),
  },
  {
    name: I18n.str('fleet', 'Fleet'),
    type: 'Autocomplete',
    accessor: 'fleetIds',
    optionName: 'fleet',

    api: true,
    getOptions: getFleetByName,
  },
  {
    name: I18n.str('ownership', 'Ownership'),
    type: 'Autocomplete',
    accessor: 'ownershipTypes',
    optionName: 'ownership',

    api: false,
    options: OWNERSHIP_TYPES,
  },
  {
    name: I18n.str('tempClassification', 'Temp Classification'),
    type: 'Autocomplete',
    accessor: 'tempClassification',
    api: false,
    optionName: 'tempClass',

    options: getOptions(TEMP_CLASSIFICATIONS),
  },
  {
    name: I18n.str('strategyType', 'Strategy Type'),
    type: 'Autocomplete',
    accessor: 'shippingStrategy',
    optionName: 'strategyType',

    api: false,
    options: getOptions(STRATEGY_TYPES),
  },
];
